import { Chain, ChainID } from '@ankr.com/chains-list';
import { Typography } from '@mui/material';
import { t } from '@ankr.com/common';

import { ChainLogo } from 'modules/chains/components/ChainLogo';
import { Dialog } from 'uiKit/Dialog';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

import { ChainSelectors } from './components/ChainSelectors';
import { ChainSelectorsProvider } from '../ChainSelectorsProvider';
import { CodeSnippet } from './components/CodeSnippet';
import { MultichainCodeExample } from '../MultichainCodeExample';
import { useCodeExampleModalStyles } from './useCodeExampleModalStyles';

interface ICodeExampleModalProps {
  chain: Chain;
  isOpenedCodeExample: boolean;
  onCloseCodeExample: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const onDialogClick = (event: React.MouseEvent) => event.stopPropagation();

export const CodeExampleModal = ({
  chain,
  isOpenedCodeExample,
  onCloseCodeExample,
}: ICodeExampleModalProps) => {
  const { isEnterprise } = useAccountStatus();

  const multichainUrl = isEnterprise
    ? chain.urls[0]?.enterprise
    : chain.urls[0]?.rpc;

  const { classes } = useCodeExampleModalStyles();

  return (
    <ChainSelectorsProvider chain={chain} hasConsensusSwitch={false}>
      <Dialog
        onClick={onDialogClick}
        onClose={onCloseCodeExample}
        open={isOpenedCodeExample}
        paperClassName={classes.snippetsDialogPaper}
        shouldStopPropagationOnClose
        title={t('chain-item.get-started.connection-snippet.title')}
        titleClassName={classes.snippetsDialogTitle}
      >
        <div className={classes.chainDescription}>
          <ChainLogo
            className={classes.codeExampleModalChainLogo}
            chain={chain}
          />
          <Typography variant="subtitle2" color="textPrimary">
            {chain.name}
          </Typography>
        </div>

        {chain.id === ChainID.MULTICHAIN ? (
          <MultichainCodeExample url={multichainUrl} />
        ) : (
          <>
            <ChainSelectors />
            <CodeSnippet />
          </>
        )}
      </Dialog>
    </ChainSelectorsProvider>
  );
};
